import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { initApplicationSelector } from '../store/Application/ApplicationSelector';
import { ApplicationState } from '../store/Application/ApplicationReducer';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(private readonly titleService: Title,
              private readonly applicationStore: Store<ApplicationState>) {
  }

  ngOnInit(): void {
    this.applicationStore.select(initApplicationSelector).subscribe((config) => {
      this.titleService.setTitle(config.title);
    });
  }
}
